export enum ContractAnnexLineCharge {
  discount = 'discount'
}
